import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow } from "@/components/shared/Eyebrow";
import { Reveal } from "@/components/shared/Reveal";

const IMG = "https://images.unsplash.com/photo-1780034766228-3fd70d9463c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export function Intro() {
  return (
    <section data-testid="intro-section" className="relative bg-light py-24 md:py-28 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8">
        <Eyebrow className="mb-10">SİSTEM ELEKTRİK & MÜHENDİSLİK</Eyebrow>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="font-head font-extrabold text-ink tracking-tighter text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
                Mühendislik.<br />
                Teknoloji.<br />
                <span className="text-tech">Güven.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl text-lg text-ink/70 leading-relaxed">
                Sistem Elektrik ve Mühendislik olarak; endüstriyel elektrik, otomasyon ve
                mühendislik alanlarında karmaşık projeleri güvenle hayata geçiriyoruz.
                Keşiften tasarıma, uygulamadan devreye almaya kadar her aşamada
                mühendislik disiplinini ve teknik mükemmelliği esas alıyoruz.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <Link
                to="/kurumsal"
                data-testid="intro-about-link"
                className="mt-10 inline-flex items-center gap-2 text-tech font-semibold group"
              >
                Bizi Daha Yakından Tanıyın
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <motion.div
              className="relative aspect-[4/5] overflow-hidden bg-navy"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            >
              <img src={IMG} alt="Endüstriyel mühendislik" className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-cyan/40 bg-navy/40 backdrop-blur-sm">
                <p className="text-cyan text-xs tracking-[0.25em] uppercase">Precision & Reliability</p>
                <p className="text-white text-sm mt-1">Sahada mühendislik mükemmelliği</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
